import { api } from "@api/api";
import { MagazineTemplate } from "@modules/magazineTemplates/types";
import { MagazineTemplateFormValues } from "@modules/magazineTemplates/validations";
import { appendFormData } from "@core/utils/appendFormData";

export async function editMagazineTemplateService(id: string, data: MagazineTemplateFormValues): Promise<MagazineTemplate> {
  const payload = appendFormData(data);

  const { data: magazinetemplate } = await api.patch<MagazineTemplate>(
    `v2/magazine/magazine_template_admin/${id}/`,
    payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return magazinetemplate;
}
